<template>
    <div class="member-call-box search">
        <form action="" @submit.prevent="false == false">
            <div class="search_ty1"> 
                <input type="text" required :placeholder="$i18nUtil.trans('message.MemberCallSearch.001','이름으로 검색')" ref="searchInput"  @input="searchByKeyword" @keydown="searchByKeyword">
                <button type="reset" class="btn_search" @click="userList =[],isSearch=false">검색</button>
            </div>
        </form>
        <div class="scroll" >
            <div class="nodata" v-if="!isSearch">
                <div class="txt" v-if="memberType == 'MEMBER'">{{ $i18nUtil.trans("message.MemberCallSearch.002","카테고리 멤버를 추가해주세요.") }}</div>
                <div class="txt" v-else>{{ $i18nUtil.trans("message.MemberCallSearch.003","운영자를 추가해주세요.") }}</div>
            </div>
            <div class="nodata" v-if="userList.length == 0 && isSearch">
                <div class="txt" v-html="$i18nUtil.trans('message.MemberCallSearch.004','해당 검색어와 일치하는 사용자가 없습니다.')"></div>
            </div>
            <dl v-if="userList.length != 0 && memberType == 'MEMBER'">
                <dt></dt>
                <dd> 
                    <ul class="member-list" v-if="userList.length > 0">
                        <li v-for="(item, index) in userList" 
                            :key="'member_'+index"
                            data-user-type="member"
                            :data-user-index="index"
                            @click="selectCategorytUser(item, index)">
                            <div class="img" :data-user-id="item.userId"><img src="@/assets/img/no-avatar.png" alt="" /></div>
                            <!-- <div class="img user-photo" :data-user-id="item.userId"> <img class="hidden" src="" alt="" /></div> -->
                            <b class="name ell-singleline">{{ defaultLanguage.indexOf('ko') != -1 ? item.userName : item.userNameEn != null ? item.userNameEn : item.userName }}
                                <span>{{ defaultLanguage.indexOf('ko') != -1 ? item.positionName : item.positionNameEn != null ? item.positionNameEn : item.positionName }}</span></b>
                            <span class="team ell-singleline">{{ defaultLanguage.indexOf('ko') != -1 ? item.companyName : item.companyNameEn != null ? item.companyNameEn : item.companyName }}
                                 / {{ defaultLanguage.indexOf('ko') != -1 ? item.deptName : item.deptNameEn != null ? item.deptNameEn : item.deptName }}</span>
                        </li> 
                    </ul>
                    <div class="nodata" v-else-if="userList == null || userList.length == 0" v-html="$i18nUtil.trans('message.MemberCallSearch.004','해당 검색어와 일치하는 사용자가 없습니다.')"></div>
                </dd>
            </dl><!-- defaultLanguage.indexOf('ko') != -1 ? user.userName : user.userNameEn != null ? user.userNameEn+'bb' : user.userName -->
            <dl v-if="userList.length != 0 && memberType == 'MANAGER'">
                <dt>{{ $i18nUtil.trans("message.member.searchResult","멤버 검색 결과") }}</dt>
                <dd> 
                    <ul class="member-list" v-if="searchMemberList.length > 0">
                        <li v-for="(item, index) in searchMemberList" 
                            :key="'user_'+index"
                            data-user-type="user"
                            :data-user-index="index"
                            @click="selectCategorytUser(item, index)">
                            <div class="img" :data-user-id="item.userId"><img src="@/assets/img/no-avatar.png" alt="" /></div>
                            <!-- <div class="img user-photo" :data-user-id="item.userId"> <img class="hidden" src="" alt="" /></div> -->
                            <b class="name ell-singleline">{{ defaultLanguage.indexOf('ko') != -1 ? item.userName : item.userNameEn != null ? item.userNameEn : item.userName }} 
                                <span>{{ defaultLanguage.indexOf('ko') != -1 ? item.positionName : item.positionNameEn != null ? item.positionNameEn : item.positionName }}</span></b>
                            <span class="team ell-singleline">{{ defaultLanguage.indexOf('ko') != -1 ? item.companyName : item.companyNameEn != null ? item.companyNameEn : item.companyName }} 
                                / {{ defaultLanguage.indexOf('ko') != -1 ? item.deptName : item.deptNameEn != null ? item.deptNameEn : item.deptName }}</span>
                        </li> 
                    </ul>
                    <div class="nodata" v-else-if="searchMemberList == null || searchMemberList.length == 0" v-html="$i18nUtil.trans('message.MemberCallSearch.004','해당 검색어와 일치하는 사용자가 없습니다.')"></div>
                </dd>
            </dl>
            <dl v-if="userList.length != 0 && memberType == 'MANAGER'">
                <dt v-html="$i18nUtil.trans('message.MemberCallSearch.005','멤버 외 검색 결과 (등록 완료 시 멤버로 자동 추가됩니다.)')"></dt>
                <dd>
                    <ul class="member-list" v-if="searchNoneMemberList.length > 0">
                        <li v-for="(item, index) in searchNoneMemberList"
                            :key="'noneUser_'+index"
                            data-user-type="nonuser"
                            :data-user-index="index"
                            @click="selectCategorytUser(item, index)">
                            <div class="img" :data-user-id="item.userId"><img src="@/assets/img/no-avatar.png" alt=""></div>
                            <!-- <div class="img user-photo" :data-user-id="item.userId"> <img class="hidden" src="" alt="" /> </div> -->
                            <b class="name ell-singleline">{{ defaultLanguage.indexOf('ko') != -1 ? item.userName : item.userNameEn != null ? item.userNameEn : item.userName }}
                                <span>{{ defaultLanguage.indexOf('ko') != -1 ? item.positionName : item.positionNameEn != null ? item.positionNameEn : item.positionName }}</span></b>
                            <span class="team ell-singleline">{{ defaultLanguage.indexOf('ko') != -1 ? item.companyName : item.companyNameEn != null ? item.companyNameEn : item.companyName }}
                                 / {{ defaultLanguage.indexOf('ko') != -1 ? item.deptName : item.deptNameEn != null ? item.deptNameEn : item.deptName }}</span>
                        </li> 
                    </ul>
                    <div class="nodata" v-else-if="searchNoneMemberList == null || searchNoneMemberList.length == 0" v-html="$i18nUtil.trans('message.MemberCallSearch.004','해당 검색어와 일치하는 사용자가 없습니다.')"></div>
                </dd>
            </dl>
        </div>
    </div>
</template>
    
<script>
    import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
    export default {
        props:["categoryInfo",
               "memberList",
               "memberType",
               "toggleBtn"],
        // props:{
        //     categoryInfo: Array,
        //     memberList: Array,
        //     memberType: String,
        //     toggleBtn: Object,
        // } ,
        data() {
            return {
                isSearch: false,
                userList:[],
                searchMemberList:[],
                searchNoneMemberList:[], 
                state: {
                    memberIndex:[0],
                },
                toastInfo: {
                    obj: this.$toasted,
                    message: "",
                    options: {
                        theme: "toasted-primary",
                        position: "bottom-left",
                        duration: 3000,
                    },
                },

                defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
            };
        },
        mounted(){
            this.userList=[]; 
        },
        methods: { 
            ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION" ]), 
            ...mapActions("evdControl", ["SIMPLE_KBD_SCROLL"]),
            ...mapActions("modals", ["showModal", "showToast"]),
            searchByKeyword(event) {
                let self = this;
                self.SIMPLE_KBD_SCROLL({
                    event: event,
                    index: self.state.memberIndex,
                    offsetTop: -80,
                    root: self.$el, 
                    itemQuery: ".member-call-box .scroll li", 
                    scrollQuery: ".member-call-box .scroll", 
                    pointerClass: "selected",
                    onSelect(e, inx, elem) {
                        // console.log("SELECTED:", inx, elem);
                        if (elem) {
                            let userType = elem.getAttribute("data-user-type");
                            let userIndex = elem.getAttribute("data-user-index");
                            let user = null;
                            if (userType === "user") {
                                user = self.searchMemberList[userIndex];
                            }
                            else if(userType === "nonuser") {
                                user = self.searchNoneMemberList[userIndex];
                            } 
                            else {
                                user = self.userList[userIndex];
                            }
                            if (user) {
                                e.target.value = "";
                                self.selectCategorytUser(user, userIndex);
                                // self.toggleBtn.$el.click();
                            }
                        }
                    },
                    onCancel(e) {
                        // console.log("CANCELED!");
                        e.target.value = "";
                        setTimeout(() => self.searchByKeywordWrapper(e), 10);
                    },
                    callback(e, fncScroll) {
                        // console.log("SEARCHING..", e);
                        setTimeout(() => self.searchByKeywordWrapper(e, fncScroll), 10);
                    }
                });
            },
            searchByKeywordWrapper(event, fncScroll) {
                if (event.target.value.length > 1) {
                    this.isSearch = true;

                    /* 부서 & 유저 */
                    let searchKeyword = event.target.value;
                    let searchCondition = "user";

                    let obj = this;
                    let reqData = {};
                    reqData.params ={
                        searchKeyword: event.target.value
                    };
                    reqData.req = obj.req;
                    reqData.url = "/api/auth/org/searchByUserName";
                    reqData.method = "post";

                    obj
                    .COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(function (data) {
                        obj.userList = data.result; 
                        obj.searchNoneMemberList = [];
                        obj.searchMemberList = []; 

                        obj.userList.forEach((item) => {
                            let memberCheck = false;

                            obj.memberList.forEach((value) => {
                                if (value.userId == item.userId) {
                                    memberCheck = true;
                                }
                            });
                            if (memberCheck) {
                                obj.searchMemberList.push(item);
                            } else {
                                obj.searchNoneMemberList.push(item);
                            }
                        });    
                        if (fncScroll) {
                            obj.state.memberIndex[0] = 0;
                            fncScroll(obj.state.memberIndex);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
                } else {
                    this.userList=[];
                    this.isSearch = false;
                }
            },
            selectCategorytUser(item, index){
                this.$refs.searchInput.value = "";
                this.userList=[];
                this.isSearch=false;

                if(this.categoryInfo.section == "CFRC"){
                    // 멤버가 차단 벽에 막히는지 확인 !
                    let obj = this;
                    let reqData = {};
                    reqData.params ={
                        categoryMid: this.categoryInfo.categoryMid,
                        addUserId: item.userId
                    }
                    reqData.req = obj.req;
                    reqData.url = "/api/copaper/cooperation/checkPolicy";
                    reqData.method = "post";
                    obj.COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(res => {
                        if(res.result.checkPolicy && res.result.checkPolicy.length >0 ){
                            let checkPolicy = "";
                            res.result.checkPolicy.forEach((res)=>{
                                checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
                            })
                            obj.showAlertDialog(obj.$i18nUtil.trans("AB112",{ checkPolicy: checkPolicy}));
                            return;
                        }

                        if(res.result.policyBlockUserList && res.result.policyBlockUserList.length > 0) {
                            this.toastInfo.message = this.$i18nUtil.trans("message.MemberCallSearch.006","정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.");
                            this.userList = [];
                            this.searchMemberList = [];
                            this.searchNoneMemberList = [];
                            this.showToast(this.toastInfo);
                            this.$refs.searchInput.focus();
                        }else{
                            if(this.memberType == "MEMBER"){
                                this.$emit("selectedMemberUser",item);
                            }else{//memberType == "MANAGER"
                                this.$emit("selectedManagerUser",item);
                            }
                            this.toggleBtn.$el.click();
                        }
                    }) 
                    .catch(function(err) {
                        console.log(err);
                    });
                }else{
                    if(this.memberType == "MEMBER"){
                        this.$emit("selectedMemberUser",item);
                    }else{//memberType == "MANAGER"
                        this.$emit("selectedManagerUser",item);
                    }
                    this.toggleBtn.$el.click();
                }
            },
            existMember(){
                let obj = this;
                obj.toastInfo.message = obj.$i18nUtil.trans("AB079");//;
                obj.showToast(obj.toastInfo);
            }
        }
    }
</script>
<style scoped>
.member-call-box .scroll ul li.selected {
  background: #eaecf0;
}

.dropdown-list > .member-call-box.search .scroll{
    height: calc(100% - 70px);
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/modal/MemberCallSearch.vue